<template>
    <div
        id="liteMap"
        :style="{ width: mapOptions.width, height: mapOptions.height }"
    ></div>
</template>

<script>
import axios from "axios";
export default {
    name: "LiteMap",
    props: {
        mapOptions: {
            type: Object
        },
        virtualList: {
            type: Array
        },
        userInfo: {
            type: Object
        },
        stations: {
            type: Array
        }
    },
    watch: {
        virtualList() {
            this.setMapCenter();
        },
        userInfo() {
            this.setMapCenter();
        },
        stations() {
            this.setMapCenter();
        }
    },
    mounted() {
        this.initMap();
    },
    methods: {
        initMap() {
            // 创建地图实例
            this.map = new BMapLite.Map("liteMap");
            // 初始化地图，和地图级别
            var zoomCtrl = new BMapLite.ZoomControl({
                anchor: BMAP_ANCHOR_TOP_RIGHT,
                offset: new BMapLite.Size(10, 45)
            });
            this.map.addControl(zoomCtrl);
            this.$emit("initMap", this.map);
        },
        setMapCenter() {
            if (!this.virtualList[0]) {
                let location = sessionStorage.getItem("location");
                if (location) {
                    location = JSON.parse(location);
                    this.map.centerAndZoom(
                        new BMapLite.Point(location.lng, location.lat),
                        10
                    );
                } else {
                    let axios_ins = axios.create({
                        headers: {
                            "Access-Control-Allow-Origin": "*"
                        }
                    });
                    axios
                        .jsonp(
                            `http://api.map.baidu.com/geocoding/v3/?address=${this.userInfo.City}&output=json&ak=ubdHBzcYnT9edaTqowFu1n4URK2oGBjY`
                        )
                        .then(x => {
                            let p = x.result.location;
                            this.map.centerAndZoom(
                                new BMapLite.Point(p.lng, p.lat),
                                10
                            );
                            sessionStorage.setItem(
                                "location",
                                JSON.stringify(p)
                            );
                        });
                }
            } else {
                // 设置中心点坐标
                let pts = this.stations.map(x=>{
                    if(x.path.Lng && x.path.Lat) {
                        var lng = x.path.Lng
                        var lat = x.path.Lat
                        var p = new BMapLite.Point(lng,lat)
                        return p
                    }
                });
                this.map.setViewport(pts);
                const pt = this.map.getCenter();
                const p = {lng: pt.lng, lat: pt.lat};
                sessionStorage.setItem("location", JSON.stringify(p));
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/pages/application/virtual/LiteMap.vue